import 'cross-fetch/polyfill';
import * as smoothScroll from 'smoothscroll-polyfill';
smoothScroll.polyfill();
